import React, { Key, useEffect, useState } from 'react'
import './PaySlipAdmin.scss'
import { Link } from 'react-router-dom'
import { Logger } from '../../../../../Helpers/Logger'
import { HorizontalLoader, ImageSrc, ModalWrapper } from '../../../../../Components'
import Pagination from '../../../../../Components/Pagination/Pagination'
import paySlipService from 'Services/paySlipService'
import { payslipType } from 'Models'
import { CurrencyFormatter } from 'Helpers'
import Swal from 'sweetalert2'
import { useForm } from 'react-hook-form'
import CustomPayslipForm from './CustomPayslipForm'
import { String } from 'lodash'

export interface payslipFormType {
  year: string
  month: string
  userId?: string
}

const PaySlipAdmin = () => {
  const [pageNumber, setPage] = useState(1)

  const [payslip, setPaySlip] = useState<payslipType[]>()
  const [loading, setLoading] = useState(false)
  const [request, setRequest] = useState(false)

  const [showPayslipModal, setShowPayslipModal] = useState(false)
  const [showCustomPayslipModal, setShowCustomPayslipModal] = useState(false)
  const [payslipUserId, setPayslipUserId] = useState<string>()
  const [customPayslipUserId, setCustomPayslipUserId] = useState<string>()

  const [minMonth, setMinMonth] = useState('')
  const [years, setYears] = useState<number[]>([])
  const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear())

  const [selectedMonth, setSelectedMonth] = useState('')
  const [months, setMonths] = useState<{ name: string; value: number }[]>([])

  const monthNames = [
    { name: 'January', value: 1 },
    { name: 'February', value: 2 },
    { name: 'March', value: 3 },
    { name: 'April', value: 4 },
    { name: 'May', value: 5 },
    { name: 'June', value: 6 },
    { name: 'July', value: 7 },
    { name: 'August', value: 8 },
    { name: 'September', value: 9 },
    { name: 'October', value: 10 },
    { name: 'November', value: 11 },
    { name: 'December', value: 12 },
  ]

  useEffect(() => {
    const today = new Date()
    const lastMonthIndex = today.getMonth() - 1

    if (selectedYear === today.getFullYear()) {
      // Only allow current and future months, plus last month if applicable
      const futureMonths = monthNames.filter((_, index) => index >= lastMonthIndex)
      setMonths(futureMonths)
    } else {
      // Allow all months for other years
      setMonths(monthNames)
    }
  }, [selectedYear])

  useEffect(() => {
    // Set current and future years (e.g., next 10 years)
    const currentYear = new Date().getFullYear()
    const futureYears = Array.from({ length: 10 }, (_, index) => currentYear + index)
    setYears(futureYears)
  }, [])

  const [paginationData, setPaginationData] = useState<{
    pageNumber: number
    pageSize: number
    total: number
  }>({
    pageNumber: 1,
    pageSize: 20,
    total: 1,
  })

  const getPaySlip = async () => {
    setLoading(true)
    await paySlipService.index(pageNumber).then(
      (response) => {
        setLoading(false)
        setPaySlip(response?.data.data.dataset)
        console.log('response', response)

        setPaginationData({
          pageNumber: response?.data.data.pageNumber,
          pageSize: response?.data.data.pageSize,
          total: response?.data.data.total,
        })
      },
      (error: { response: object }) => {
        setLoading(false)
        Logger('response error', error.response)
      },
    )
  }

  useEffect(() => {
    getPaySlip()
  }, [pageNumber])

  const togglePayslipModal = (userId?: string) => {
    setShowPayslipModal((prevState) => !prevState)
    if (userId) setPayslipUserId(userId)
  }

  const sendPayslip = async (data: payslipFormType) => {
    setRequest(true)
    Swal.fire({
      title: 'Loading...',
      text: 'Please wait while we process your request',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    await (
      payslipUserId && payslipUserId !== undefined && payslipUserId !== 'undefined'
        ? paySlipService.sendPayslipToUser({ ...data, userId: payslipUserId })
        : paySlipService.sendPayslipToAll(data)
    ).then(
      (res) => {
        setPayslipUserId(undefined)
        Swal.close()
        setRequest(false)
        togglePayslipModal()
        Swal.fire({
          icon: 'success',
          title: 'Completed',
          text: payslipUserId
            ? 'Your request has been sent successfully!'
            : 'Your request has been sent to all employees successfully!',
        })
      },
      (error) => {
        setRequest(false)
        Swal.close()
        console.log('productService error', error.response)
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            cancelButton: 'btn btn-danger',
          },
          buttonsStyling: false,
        })

        swalWithBootstrapButtons.fire({
          title: 'Oops!',
          text: error.response.data.error,
          icon: 'warning',
          showCancelButton: true,
          showConfirmButton: false,
          cancelButtonText: 'close',
          reverseButtons: true,
        })
      },
    )
  }

  const sendPayslipNew = async (payslipUserID?: string) => {
    setRequest(true)
    Swal.fire({
      title: 'Loading...',
      text: 'Please wait while we process your request',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    const now = new Date()

    const data = {
      month: (now.getMonth() + 1).toString(), // getMonth() returns 0-based month, so add 1
      year: now.getFullYear().toString(),
    }

    await (
      payslipUserID
        ? paySlipService.sendPayslipToUser({ ...data, userId: payslipUserID })
        : paySlipService.sendPayslipToAll(data)
    ).then(
      (res) => {
        setPayslipUserId(undefined)
        Swal.close()
        setRequest(false)
        Swal.fire({
          icon: 'success',
          title: 'Completed',
          text: payslipUserId
            ? 'Your request has been sent successfully!'
            : 'Your request has been sent to all employees successfully!',
        })
      },
      (error) => {
        setRequest(false)
        Swal.close()
        console.log('productService error', error.response)
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            cancelButton: 'btn btn-danger',
          },
          buttonsStyling: false,
        })

        swalWithBootstrapButtons.fire({
          title: 'Oops!',
          text: error.response.data.error,
          icon: 'warning',
          showCancelButton: true,
          showConfirmButton: false,
          cancelButtonText: 'close',
          reverseButtons: true,
        })
      },
    )
  }

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<payslipFormType>()

  return (
    <div className='PaySlipAdmin'>
      <div className='container mt-4'>
        <div className='container'>
          <div className='card border-0'>
            <div className='card-header border-0 px-0'>
              <div className='row'>
                <div className='col-6 col-sm-6 col-md-8 my-auto'>
                  <div className='title'>Payslip List</div>
                </div>

                <div className='col-6 col-sm-6 col-md-4 my-auto text-sm-end'>
                  <button
                    className='btn btn-send me-1'
                    onClick={() => setShowCustomPayslipModal(!showCustomPayslipModal)}
                  >
                    Send Custom Payslip
                  </button>

                  <button
                    className='btn btn-send ms-1'
                    onClick={() => sendPayslipNew()}
                    disabled={request}
                  >
                    Send All Payslip
                  </button>
                </div>
              </div>
            </div>
            <div className='card-body'>
              <div className='table-responsive'>
                <table className='table'>
                  <thead>
                    <tr>
                      <td>Employee ID</td>
                      <td>Employee Name</td>
                      <td>Base Salary</td>
                      <td>Deductions</td>
                      <td>NetPay</td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    {payslip &&
                      payslip.length > 0 &&
                      payslip.map((data: payslipType, index: Key) => (
                        <tr key={index}>
                          <td>{data.userId}</td>
                          <td>
                            {data.user.firstName} {data.user.lastName}
                          </td>
                          <td>₦{CurrencyFormatter(data.totalEarnings)}</td>
                          <td>₦{CurrencyFormatter(data.totalDeductions)}</td>
                          <td>₦{CurrencyFormatter(data.netPay)}</td>
                          <td className='dropdown option-dropdown'>
                            <Link to={`/admin/payslip-admin/${data.id}`}>
                              <button className='btn btn-sm p-0 border-0'>
                                <svg
                                  width='18'
                                  height='18'
                                  viewBox='0 0 18 18'
                                  fill='none'
                                  xmlns='http://www.w3.org/2000/svg'
                                >
                                  <path
                                    d='M8.99945 12.2474C7.20695 12.2474 5.75195 10.7924 5.75195 8.99994C5.75195 7.20744 7.20695 5.75244 8.99945 5.75244C10.792 5.75244 12.247 7.20744 12.247 8.99994C12.247 10.7924 10.792 12.2474 8.99945 12.2474ZM8.99945 6.87744C7.82945 6.87744 6.87695 7.82994 6.87695 8.99994C6.87695 10.1699 7.82945 11.1224 8.99945 11.1224C10.1695 11.1224 11.122 10.1699 11.122 8.99994C11.122 7.82994 10.1695 6.87744 8.99945 6.87744Z'
                                    fill='#82858A'
                                  />
                                  <path
                                    d='M9.00055 15.7651C6.18055 15.7651 3.51805 14.1151 1.68805 11.2501C0.893047 10.0126 0.893047 7.99511 1.68805 6.75011C3.52555 3.88511 6.18805 2.23511 9.00055 2.23511C11.813 2.23511 14.4755 3.88511 16.3055 6.75011C17.1005 7.98761 17.1005 10.0051 16.3055 11.2501C14.4755 14.1151 11.813 15.7651 9.00055 15.7651ZM9.00055 3.36011C6.57805 3.36011 4.26055 4.81511 2.64055 7.35761C2.07805 8.23511 2.07805 9.76511 2.64055 10.6426C4.26055 13.1851 6.57805 14.6401 9.00055 14.6401C11.423 14.6401 13.7405 13.1851 15.3605 10.6426C15.923 9.76511 15.923 8.23511 15.3605 7.35761C13.7405 4.81511 11.423 3.36011 9.00055 3.36011Z'
                                    fill='#82858A'
                                  />
                                </svg>
                              </button>
                            </Link>

                            <button
                              className='btn border-0 dropdown-toggle'
                              data-bs-toggle='dropdown'
                              aria-expanded='false'
                              data-bs-popper-config='{"strategy":"fixed"}'
                            >
                              <svg
                                width='18'
                                height='18'
                                viewBox='0 0 18 18'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  d='M7.49991 8.4705C7.49991 7.72933 8.0955 7.14697 8.82344 7.14697C9.55138 7.14697 10.147 7.74256 10.147 8.4705C10.147 9.19844 9.55138 9.79403 8.82344 9.79403C8.0955 9.79403 7.49991 9.21168 7.49991 8.4705Z'
                                  fill='#707070'
                                />
                                <path
                                  d='M7.49991 14.1175C7.49991 13.3763 8.0955 12.7939 8.82344 12.7939C9.55138 12.7939 10.147 13.3895 10.147 14.1175C10.147 14.8454 9.55138 15.441 8.82344 15.441C8.0955 15.441 7.49991 14.8587 7.49991 14.1175Z'
                                  fill='#707070'
                                />
                                <path
                                  d='M7.49991 2.82353C7.49991 2.08235 8.0955 1.5 8.82344 1.5C9.55138 1.5 10.147 2.09559 10.147 2.82353C10.147 3.55147 9.55138 4.14706 8.82344 4.14706C8.0955 4.14706 7.49991 3.56471 7.49991 2.82353Z'
                                  fill='#707070'
                                />
                              </svg>
                            </button>

                            <ul className='dropdown-menu dropdown-menu-end export-dropdown border-0 shadow'>
                              <li className='dropdown-item'>
                                <Link
                                  to={`/admin/payslip-admin/${data.id}`}
                                  className='d-block w-100'
                                >
                                  View Details
                                </Link>
                              </li>
                              <li className='dropdown-item'>
                                <Link
                                  to={''}
                                  className='d-block w-100'
                                  onClick={() => sendPayslipNew(data.user.id)}
                                  // onClick={() => togglePayslipModal(data.user.id)}
                                >
                                  Send Pay Slip
                                </Link>
                              </li>

                              <li className='dropdown-item'>
                                <Link
                                  to={`/admin/payslip-admin/payslip-user-admin-history/${data.userId}`}
                                  className='w-100 d-block'
                                >
                                  Employee Payslip History
                                </Link>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      ))}

                    {loading === false && payslip === undefined && (
                      <tr>
                        <td colSpan={6} className='text-center'>
                          No payslip found
                        </td>
                      </tr>
                    )}
                    {loading === true && payslip === undefined && (
                      <tr>
                        <td colSpan={6} className='text-center'>
                          <HorizontalLoader></HorizontalLoader>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {paginationData.total >= paginationData.pageSize && (
                <div className='pagination w-100 d-flex justify-content-center'>
                  {paginationData.total && (
                    <Pagination
                      className='pagination-bar ps-0'
                      currentPage={Number(paginationData.pageNumber)}
                      totalCount={paginationData.total}
                      pageSize={paginationData.pageSize}
                      onPageChange={(page: React.SetStateAction<number>) => setPage(page)}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <ModalWrapper
        showModal={showPayslipModal}
        closeModal={togglePayslipModal}
        title='Send Payslip'
      >
        <form onSubmit={handleSubmit(sendPayslip)}>
          <div className='form-group mb-3'>
            <label htmlFor='year-select'>Select Year:</label>
            <select
              id='year-select'
              className='form-control'
              value={selectedYear}
              {...register('year', {
                required: 'Year is required',
                onChange: (e) => setSelectedYear(parseInt(e.target.value)),
              })}
            >
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
            {errors.year && <small className='text-danger'>{errors.year.message}</small>}
          </div>

          <div className='form-group mb-3'>
            <label htmlFor='month-select'>Select Month:</label>

            <select
              {...register('month', {
                required: 'Month is required',
                onChange: (e) => setSelectedMonth(e.target.value),
              })}
              id='month-select'
              className='form-control'
              value={selectedMonth}
            >
              <option value='' disabled>
                -- Select Month --
              </option>
              {months.map((month) => (
                <option key={month.value} value={month.name}>
                  {month.name}
                </option>
              ))}
            </select>
            {errors.month && <small className='text-danger'>{errors.month.message}</small>}
          </div>

          <div className='form-group mb-3'>
            <button type='submit' className='btn btn-default btn-0'>
              Send {request && <span className='spinner-border spinner-border-sm'></span>}
            </button>
          </div>
        </form>
      </ModalWrapper>

      <ModalWrapper
        showModal={showCustomPayslipModal}
        closeModal={() => setShowCustomPayslipModal(false)}
        title='Send Custom Payslip'
        size='lg'
      >
        <CustomPayslipForm
          customPayslipUserId={customPayslipUserId}
          togglePayslipModal={() => setShowCustomPayslipModal(!showCustomPayslipModal)}
        ></CustomPayslipForm>
      </ModalWrapper>
    </div>
  )
}

export default PaySlipAdmin
